import React from "react"
// import { StaticImage } from "gatsby-plugin-image"//ローカルから画像を持ってくる
import { TitleAnimation } from '../index'
// import { LinkButton } from "../index"
// import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import * as styles from "./RecruitNews.module.scss"
import RecruitNewsList from "./RecruitNewsList"

const RecruitNews = () => {

  // const breakpoints = useBreakpoint();

  const title1 = [
    { "id": 0, "text": "r" },
    { "id": 1, "text": "e" },
    { "id": 2, "text": "c" },
    { "id": 3, "text": "r" },
    { "id": 4, "text": "u" },
    { "id": 5, "text": "i" },
    { "id": 6, "text": "t" },
    { "id": 7, "text": "" },
    { "id": 8, "text": "n" },
    { "id": 9, "text": "e" },
    { "id": 10, "text": "w" },
    { "id": 11, "text": "s" },
  ];

  return (
      <div className={styles.News__wrp}>
        <div className={styles.News}>
          <TitleAnimation data={title1} className={`titleRubikCenter`} />
          <h2 className={`subH2`}>求人に関するお知らせ</h2>
          <div className={styles.contents}>
            <RecruitNewsList className={styles.List} />
          </div>
        </div>
        {/* <LinkButton to="/categories/recruit-news">お知らせ一覧</LinkButton> */}
      </div>
  )
}
export default RecruitNews